/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";
import ArgosErrorMessage from "../../../../../components/ErrorMessage/ArgosErrorMessage";
import Loader from "../../../../../components/Loader/Loader";
import { RightPanelPlot } from "./RightPanelPlot";
import { useHasWriteAccess } from "../../../../../../redux/ducks/AccessControl/accessControlHelpers";

interface IRightPanelProps{
  isLoadingPlot : boolean
  isError: boolean
  plotData: any
  handleUpdatePlot: any
  baselineData: any
  handleReset: any 
  handleClickSaveOpen : any
  openSavePopup: any
  handleClose: any
  handleSaveConfigName: any
  configName : string
  configIndex: any
  gmid: any
  onOverrideConfiguration: any
  onSaveConfiguration: any
  onDeleteConfiguration: any
  fovAndBoresightUltrasonicValues: any
}

const RightPanel = (props: IRightPanelProps) => {

  return (<ArgosFlexbox style={{overflow: 'auto', width: "100%"}} vertical>
  <Loader isLoading={props?.isLoadingPlot}>
    {props?.isError ? <ArgosErrorMessage/> : <RightPanelPlot data={props?.plotData} fovAndBoresightUltrasonicValues={props?.fovAndBoresightUltrasonicValues}/>}
  </Loader>
  
</ArgosFlexbox>)
}
export default RightPanel;